import {
    useCallback,
} from 'react'

import {
    useMutation,
} from '@tanstack/react-query'

import {
    noop,
} from 'lodash'
import simpleApi from 'app/services/simpleApi'
import {
    useJWTToken,
} from 'app/Auth'
import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import requests from '../ValueMapping.requests'
import {
    Domain, ValueMappingRequest, ValueMappingResponse,
} from '../ValueMapping.types'

export default ({
    onSuccess = noop,
    configId,
}: Readonly<{
    configId: string,
    onSuccess?: (p?: boolean) => void
}>) => {
    const token = useJWTToken()

    const {
        onStartSaving,
        removePendingStatus,
        onError,
    } = useHandleStatusRequest({
        id: `${configId}-value-mapping`,
    })

    const onSuccessAction = useCallback((positive: boolean) => {
        removePendingStatus()
        onSuccess(positive)
    }, [
        removePendingStatus,
        onSuccess,
    ])

    const {
        mutateAsync: getValueMapping,
    } = useMutation({
        mutationFn: (params: ValueMappingRequest) => {
            return simpleApi({
                ...requests.getValueMapping(params),
                token,
            })
        },
        onError,
    })

    return useCallback(async (values: Map<Domain, Set<string>>) => {
        onStartSaving('Checking Database for results')
        onSuccess(false)
        const mapResult = new Map()

        return Promise.all(Array.from(values, async ([
            domain,
            data,
        ]) => {
            return mapResult.set(domain, await getValueMapping({
                domain, data: Array.from(data),
            }))
        })).then(() => {
            onSuccessAction(true)
            return mapResult as Map<Domain, ValueMappingResponse[]>
        }).catch(() => {
            onSuccessAction(true)
            return mapResult as Map<Domain, ValueMappingResponse[]>
        })
    }, [
        onStartSaving,
        onSuccess,
        getValueMapping,
        onSuccessAction,
    ])
}
